// Generated by purs version 0.13.0
"use strict";
var Chip_Component = require("../Chip.Component/index.js");
var Chip_Lib_JSON = require("../Chip.Lib.JSON/index.js");
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Timer = require("../Effect.Timer/index.js");
var Halogen_Aff_Util = require("../Halogen.Aff.Util/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_VDom_Driver = require("../Halogen.VDom.Driver/index.js");
var Simple_JSON = require("../Simple.JSON/index.js");
var Web_Event_EventTarget = require("../Web.Event.EventTarget/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_HTMLDocument = require("../Web.HTML.HTMLDocument/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var Web_UIEvent_KeyboardEvent_EventTypes = require("../Web.UIEvent.KeyboardEvent.EventTypes/index.js");
var tickInterval = function (game) {
    return Data_Functor["void"](Effect.functorEffect)(Effect_Timer.setInterval(Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt)(1000)(Chip_Component.ticksPerSecond))(Data_Functor["void"](Effect.functorEffect)(Effect_Aff.launchAff(game.query(Halogen_Query.tell(Chip_Component.Tick.create))))));
};
var on = function (eventType) {
    return function (document) {
        return function (fn) {
            return function __do() {
                var v = Web_Event_EventTarget.eventListener((function () {
                    var $12 = Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)((function () {
                        var $14 = Data_Functor["void"](Effect.functorEffect);
                        return function ($15) {
                            return $14(Effect_Aff.launchAff(fn($15)));
                        };
                    })());
                    return function ($13) {
                        return $12(Web_UIEvent_KeyboardEvent.fromEvent($13));
                    };
                })())();
                return Web_Event_EventTarget.addEventListener(eventType)(v)(false)(Web_HTML_HTMLDocument.toEventTarget(document))();
            };
        };
    };
};
var main = Halogen_Aff_Util.runHalogenAff(Control_Bind.bind(Effect_Aff.bindAff)(Halogen_Aff_Util.awaitBody)(function (v) {
    return Control_Bind.bind(Effect_Aff.bindAff)(Chip_Lib_JSON.getJSON(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "blocks";
    }))(Simple_JSON.readArray(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsNil)()())()())))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "chips";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "grid";
    }))(Simple_JSON.readArray(Simple_JSON.readString))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "hint";
    }))(Simple_JSON.readMaybe(Simple_JSON.readString))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "name";
    }))(Simple_JSON.readString)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "timeLimit";
    }))(Simple_JSON.readMaybe(Simple_JSON.readInt))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "trapConnections";
    }))(Simple_JSON.readMaybe(Simple_JSON.readArray(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "button";
    }))(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsNil)()())()()))(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "trap";
    }))(Simple_JSON.readRecord()(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "x";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "y";
    }))(Simple_JSON.readInt)(Simple_JSON.readFieldsNil)()())()()))(Simple_JSON.readFieldsNil)()())()()))))(Simple_JSON.readFieldsNil)()())()())()())()())()())()())()()))("levels/1.json"))(function (v1) {
        if (v1 instanceof Data_Maybe.Just) {
            return Control_Bind.bind(Effect_Aff.bindAff)(Halogen_VDom_Driver.runUI(Chip_Component.component(v1.value0)(1))(Data_Unit.unit)(v))(function (v2) {
                return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(tickInterval(v2)))(function () {
                    return Control_Bind.bind(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(Control_Bind.bindFlipped(Effect.bindEffect)(Web_HTML_Window.document)(Web_HTML.window)))(function (v3) {
                        return Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Class.liftEffect(Effect_Aff.monadEffectAff)(function __do() {
                            on(Web_UIEvent_KeyboardEvent_EventTypes.keyup)(v3)(function ($16) {
                                return v2.query(Halogen_Query.tell(Chip_Component.KeyboardUp.create($16)));
                            })();
                            return on(Web_UIEvent_KeyboardEvent_EventTypes.keydown)(v3)(function ($17) {
                                return v2.query(Halogen_Query.tell(Chip_Component.KeyboardDown.create($17)));
                            })();
                        }))(function () {
                            return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit);
                        });
                    });
                });
            });
        };
        if (v1 instanceof Data_Maybe.Nothing) {
            return Control_Applicative.pure(Effect_Aff.applicativeAff)(Data_Unit.unit);
        };
        throw new Error("Failed pattern match at Main (line 33, column 3 - line 45, column 16): " + [ v1.constructor.name ]);
    });
}));
module.exports = {
    main: main
};
